<template>
  <div>

    <div v-if="requestStatus || !userData" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>


    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar ref="previewEl" :src="form.avatar" :text="avatarText(form.name)"
          :variant="`light-${resolveUserRoleVariant(form.role)}`" size="90px" rounded />
      </template>
      <h4 class="mb-1">
        {{ form.name }}

      </h4>
      <div class="d-flex flex-wrap">
        <b-button variant="primary" @click="$refs.refInputEl.click()">
          <input ref="refInputEl" type="file" class="d-none" @input="inputImageRenderer">
          <span class="d-none d-sm-inline">{{ $t('update') }}</span>
          <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
        </b-button>
        <b-button variant="outline-secondary" class="ml-1">
          <span class="d-none d-sm-inline">{{ $t('remove') }}</span>
          <feather-icon icon="TrashIcon" class="d-inline d-sm-none" />
        </b-button>
      </div>
    </b-media>



    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('General Information') }}
      </h4>
    </div>

    <!-- User Info: Input Fields -->
    <b-form class="mt-2">
      <b-row>

        <!-- Field: name -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('Name')" label-for="username">
            <b-form-input id="username" v-model="form.name" :state="errors && ('name' in errors) ? false : null" />
            <small v-if="errors && ('name' in errors)" class="text-danger">
              {{ $t(errors['name'][0]) }}
            </small>
          </b-form-group>
        </b-col>


        <!-- Field: Email -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('Email')" label-for="email">
            <b-form-input :state="errors && ('email' in errors) ? false : null" id="email" v-model="form.email"
              type="email" />
            <small v-if="errors && ('email' in errors)" class="text-danger">
              {{ $t(errors['email'][0]) }}
            </small>
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('Status')" label-for="user-status">
            <v-select v-model="form.enabled" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions" :reduce="val => val.value" label="title" :clearable="false"
              input-id="user-status" />
            <small v-if="errors && ('enabled' in errors)" class="text-danger">
              {{ $t(errors['enabled'][0]) }}
            </small>
          </b-form-group>
        </b-col>

        <!-- Field: manager -->
        <!--        <b-col cols="12" md="6">-->
        <!--          <b-form-group :label="$t('Manager')" label-for="user-manager">-->
        <!--            <v-select-->
        <!--                v-model="form.manager_id"-->
        <!--                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
        <!--                :options="managersOptions"-->
        <!--                :reduce="val => val.id"-->
        <!--                label="name"-->
        <!--                :clearable="false"-->
        <!--                input-id="user-manager"-->
        <!--            />-->
        <!--&lt;!&ndash;            <small v-if="form.errors.has('manager')" class="text-danger">&ndash;&gt;-->
        <!--&lt;!&ndash;              {{ $t(form.errors.get('manager')) }}&ndash;&gt;-->
        <!--&lt;!&ndash;            </small>&ndash;&gt;-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->

        <!--        &lt;!&ndash; Field: Role &ndash;&gt;-->
        <!--        <b-col cols="12" md="6" v-if="$store.state.auth_user.userData.role.includes('admin')">-->
        <!--          <b-form-group :label="$t('User Role')" label-for="user-role">-->
        <!--            <v-select-->
        <!--              v-model="form.role"-->
        <!--              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
        <!--              :options="rolesOptions"-->
        <!--              :clearable="false"-->
        <!--              input-id="user-role"-->
        <!--            />-->
        <!--&lt;!&ndash;            <small v-if="form.errors.has('role')" class="text-danger">&ndash;&gt;-->
        <!--&lt;!&ndash;              {{ $t(form.errors.get('role')) }}&ndash;&gt;-->
        <!--&lt;!&ndash;            </small>&ndash;&gt;-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->

        <!-- Field: Expire Date -->
        <b-col cols="12" md="6" lg="6">
          <b-form-group :label="$t('Expire Date')" label-for="birth-date">
            <flat-pickr v-model="form.expire_at" :state="null" class="form-control" :config="{ dateFormat: 'Y-m-d', }"
              placeholder="YYYY-MM-DD" />
            <small v-if="errors && ('expire_at' in errors)" class="text-danger">
              {{ $t(errors['expire_at'][0]) }}
            </small>

          </b-form-group>
        </b-col>

      </b-row>
      <!-- create user from admin account select role start -->
      <div v-if="$store.state.auth.userData.roles.includes(this.$roles.SUPER_ADMIN)">

        <b-row>
          <b-col cols="6" md="6">
            <!-- left char -->
            <b-form-group :label="$t('Is manager')" label-for="plate-left-char">
              <b-form-checkbox v-model="form.isManager" :value="true" />

              <small v-if="errors && ('isManager' in errors)" class="text-danger">
                {{ $t(errors['isManager'][0]) }}
              </small>

            </b-form-group>
          </b-col>


          <b-col v-if="!form.isManager" cols="6" md="6">
            <b-form-group :label="$t('The Manager')" label-for="user-status">
              <v-select v-model="form.manager_id" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[...managersOptions]" :reduce="val => val.id" label="name" :clearable="false"
                input-id="user-status" />
              <small v-if="errors && ('manager_id' in errors)" class="text-danger">
                {{ $t(errors['manager_id'][0]) }}
              </small>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col cols="12" >
            <b-form-group :label="$t('Cam Username')" label-for="cam_username">
              <b-form-input id="cam_username" v-model="form.cam_username" />
                  <small v-if="errors && ('cam_username' in errors)" class="text-danger">
                    {{ $t(errors['cam_username'][0]) }}
                  </small>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group :label="$t('Cam Password')" label-for="cam_password">
              <b-form-input id="cam_password" :state="null" v-model="form.cam_password"
              />
              <small v-if="errors && ('cam_password' in errors)" class="text-danger">
                {{ $t(errors['cam_password'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- Header: Wasl Info -->
          <b-col cols="12" md="12" >
            <b-form-group :label="$t('Wasl Key')" label-for="referenceKey">
              <b-form-input id="referenceKey" v-model="form.referenceKey" :state="errors && ('referenceKey' in errors) ? false : null" />
              <small v-if="errors && ('referenceKey' in errors)" class="text-danger">
                {{ $t(errors['referenceKey'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>

      </div>
      <!-- create user from admin account select role  end -->



    </b-form>

    <!-- Action Buttons -->
    <b-button type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="submit">
      {{ $t('Save Changes') }}
    </b-button>
    <b-button variant="outline-secondary" type="reset" :block="$store.getters['app/currentBreakPoint'] === 'xs'">
      {{ $t('Reset') }}
    </b-button>
  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { computed, onUnmounted, ref } from '@vue/composition-api'
import useUsersList from '../users-list/useUsersList'
import { OrbitSpinner } from 'epic-spinners'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import userStoreModule from '@/views/modules/user/userStoreModule'
import useUserEdit from '@/views/modules/user/users-edit/useUserEdit'


export default {
  components: {
    flatPickr,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    OrbitSpinner,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {

    const USER_ = 'appUser'
    if (!store.hasModule(USER_)) store.registerModule(USER_, userStoreModule)
    onUnmounted(() => {
      if (store.hasModule(USER_)) store.unregisterModule(USER_)
    })

    const errors = ref([])
    const waslErrors = ref({})

    const { resolveUserRoleVariant } = useUsersList()

    const { form, managersOptions, statusOptions, requestStatus } = useUserEdit()

    for (const i in props.userData) {
      form[i] = props.userData[i]


    }
    if (props.userData.company != undefined) {

      for (const i in props.userData.company) {
        form[i] = props.userData.company[i]


      }
      // let waslData=props.userData.company;
      // form.identityNumber=waslData.identityNumber

    }

    // console.log('user data is', props.userData)

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      form.avatar = base64
    })


    const toaster = (msg, variant, title) => {
      root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }


    const submit = () => {
      requestStatus.value = true
      store.dispatch('appUser/editUser', form).then(res => {
        requestStatus.value = false

        toaster('User Updated successfully', 'success', 'success')

      })
        .catch(res => {
          if (res.response.status === 422) {
            errors.value = res.response.data.errors
            console.log('validations ', errors.value)
          }
        })
        .finally(() => {
          requestStatus.value = false
        })


    }

    return {
      errors,
      form,
      managersOptions,
      statusOptions,
      requestStatus,
      resolveUserRoleVariant,
      avatarText,

      submit,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      waslErrors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
